module.exports = __webpack_public_path__ + "static/media/business-leader-list-new.68f77a18.jpg";